import React from "react";

import { Modal } from "@shared/components";
import { useTranslate } from "@refinedev/core";

import { CategoryForm } from "../CategoryForm";
import { CreateCategoryModalProps } from "./types";
import { useCreateCategoryModal } from "./controller";

export const CreateCategoryModal = React.memo(
  ({ modalRef, onComplete }: CreateCategoryModalProps) => {
  const translate = useTranslate();

  const { methods, mutateAsync, isPending } = useCreateCategoryModal(modalRef, onComplete);

  return (
    <Modal
      ref={modalRef}
      title={translate("category_admin.titles.create")}
      onConfirm={mutateAsync}
      methods={methods}
      isPending={isPending}
    >
      <CategoryForm />
    </Modal>
  );
});
